/**
 * Cloudflare Turnstile constants (signup bot check).
 */

/** Turnstile's loader, explicit render mode. The CSP allows this host in script-src and frame-src. */
export const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

/** Sent with the token; visible in Cloudflare analytics. */
export const TURNSTILE_ACTION = 'signup';
